import {
  useDateFormat,
} from '@vueuse/core';

// #region STTEDRA
import {
  // useDev,
  useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

const {
  getNumber,
  getArrayFilled,
  getDate,
  getString,
} = useNormalizer();

export default class AcceptedDataListModelState {
  constructor(data, countryEU = [], isLogged = false, isTutor = false) {
    this[`Número de identificación`] = this.getStringToUpperCase(data.identificationNumber);
    this[`Fecha de validez del DNI `] = this.getDateTimeStamp(data.validDateDNI);
    this[`Número de soporte del NIE `] = this.getStringToUpperCase(data.supportNumber);
    this[`Nombre `] = this.getStringToUpperCase(data.name);
    this[`Apellido 1 `] = this.getStringToUpperCase(data.surname);
    this[`Apellido 2 `] = this.getStringToUpperCase(data.secondSurname);
    this[`Fecha de nacimiento `] = this.getDateTimeStamp(data.birthDate);
    this[`Nacionalidad `] = this.getNationality(data.countryEU, countryEU);
    this[`Correo`] = data.email;
    this[`Teléfono`] = data.phone;
    if (isTutor) {
      this[`Parentesco`] = this.getStringToUpperCase(data.legalRelationshipType.name);
    }
  }

  getStringToUpperCase(value) {
    if (!getString(value)) return null;
    return value.toUpperCase();
  }

  getDateTimeStamp(date) {
    if (!getDate(date)) return null;
    return useDateFormat(date, 'DD/MM/YYYY').value;
  }

  getNationality(countryEU, countryEUList) {
    if (!getNumber(countryEU)) return null;
    if (!getArrayFilled(countryEUList)) return countryEU;

    const country = countryEUList.find((x) => x.id === countryEU);
    if (!country) return countryEU;

    return country.nameSpanish;
  }
}
